/**
 * Componente de autocompletado personalizado con estilos CSS.
 * @module CssAutocomplete
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento de autocompletado personalizado.
 */
import { Autocomplete, styled } from "@mui/material";

/**
 * Componente de autocompletado personalizado con estilos CSS.
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento de autocompletado personalizado.
 */
export const CssAutocomplete = styled(Autocomplete)({
  width: "90%",
  margin: 10,
  backgroundColor: "#FCFCFC",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
    borderWidth: 3,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#C4C4C4",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&:hover fieldset": {
      borderColor: "yellow",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&.Mui-focused fieldset": {
      borderColor: "green",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
  },
});
